export default __webpack_public_path__ + "static/artgreetings-3692f262b70429ac2dbf6e04e25108ed.png";